import React from 'react';
import { FiBriefcase, FiUser, FiMail, FiPhone } from 'react-icons/fi';
import { SectionTitle, InfoField } from '../shared/ModalHelpers';

const EntityDetailsCard = ({ order }) => (
    <div className="space-y-6 bg-[var(--bg-card)] p-8 rounded-[2.5rem] border border-[var(--border-color)] shadow-sm">
        <SectionTitle icon={FiBriefcase} title="DADOS DA EMPRESA" />
        <InfoField label="Razão Social" value={order.empresa?.razaoSocial} bold font="text-lg" />
        <InfoField label="CNPJ Oficial" value={order.empresa?.cnpj} font="text-base font-mono" />
        
        <div className="h-[1px] bg-[var(--border-color)] my-4 opacity-50" />
        
        <SectionTitle icon={FiUser} title="SOLICITANTE" />
        <InfoField label="Agente Solicitante" value={order.solicitante?.nome} bold />
        <div className="space-y-2 mt-2">
            <div className="flex items-center gap-2 text-[11px] font-bold opacity-60 truncate">
                <FiMail size={14} /> {order.solicitante?.email}
            </div>
            <div className="flex items-center gap-2 text-[11px] font-bold opacity-60">
                <FiPhone size={14} /> {order.solicitante?.contato1}
            </div>
        </div>
    </div>
);

export default EntityDetailsCard;